package pl.michal_cyran.brand_hub.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import pl.michal_cyran.brand_hub.components.layouts.PageLayoutData
import pl.michal_cyran.brand_hub.pages.utils.PageContent
import pl.michal_cyran.brand_hub.subpages.main.services.MainServicesSection
import pl.michal_cyran.brand_hub.subpages.main.hero.MainHeroSection


@InitRoute
fun initIndexPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Michał Cyran"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun IndexPage() {
    Column(
        modifier = Modifier
            .fillMaxSize()
    ) {
        PageContent(
            { MainHeroSection() },
            { MainServicesSection() },
        )
    }
}